import script from "./BannerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./BannerDashboard.vue?vue&type=style&index=0&id=aa2afa90&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2afa90"]])

export default __exports__